export const FETCH_GUARDIAN_CONTACTS_BY_USER_REQUEST = 'newsletters/FETCH_GUARDIAN_CONTACTS_BY_USER_REQUEST';
export const FETCH_GUARDIAN_CONTACTS_BY_USER_SUCCESS = 'newsletters/FETCH_GUARDIAN_CONTACTS_BY_USER_SUCCESS';
export const FETCH_GUARDIAN_CONTACTS_BY_USER_FAILURE = 'newsletters/FETCH_GUARDIAN_CONTACTS_BY_USER_FAILURE';

export const fetchGuardianContactsByUserRequest = (payload = {}) => ({
  type: FETCH_GUARDIAN_CONTACTS_BY_USER_REQUEST,
  payload,
});
export const fetchGuardianContactsByUserSuccess = (payload = {}) => ({
  type: FETCH_GUARDIAN_CONTACTS_BY_USER_SUCCESS,
  payload,
});
export const fetchGuardianContactsByUserFailure = (payload = {}) => ({
  type: FETCH_GUARDIAN_CONTACTS_BY_USER_FAILURE,
  payload,
});
